var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "div",
        {
          staticClass: "app-main-page",
          staticStyle: {
            height: "calc(100vh - 100px)",
            "align-items": "stretch"
          }
        },
        [
          _c(
            "cargo-left-right-resize",
            {
              staticStyle: { "min-height": "100%" },
              attrs: {
                "left-style": {
                  flex: "none",
                  "max-width": "50%",
                  width: "20%"
                },
                "right-style": { overflow: "hidden" }
              }
            },
            [
              _c(
                "template",
                {
                  style: {
                    minWidth: "250px",
                    border: "1px solid #ccc",
                    height: "100%",
                    width: "80%"
                  },
                  slot: "left"
                },
                [
                  _c("cargo-ag-grid", {
                    class: _vm.isEdit ? "not-click" : "",
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.officeDeptRoleTree.gridOptions,
                      "column-defs": _vm.officeDeptRoleTree.columnDefs,
                      "row-data": _vm.officeDeptRoleTree.rowData
                    },
                    on: { gridReady: _vm.onAgReady }
                  })
                ],
                1
              ),
              _c(
                "template",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    flex: "1",
                    height: "auto",
                    border: "1px solid #ccc"
                  },
                  slot: "right"
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "filters" },
                      [
                        _c("el-form", {
                          attrs: {
                            inline: true,
                            "label-width": "60px",
                            "label-position": "left"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "triggers",
                        style: {
                          padding: _vm.currentType === "roleTab" ? "5px" : ""
                        }
                      },
                      [
                        _vm.currentType === "roleTab"
                          ? [
                              !_vm.isEdit
                                ? [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.isEdit = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_EditPermission"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.popNoCurrentRoleUser }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_AddUser")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "danger" },
                                        on: { click: _vm.toDelUser }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_Delete")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.popNoRoleUser }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_AssignRolesToUsers"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.popScopeUser }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_SelectARangeOfUsers"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "danger" },
                                        on: {
                                          click: function($event) {
                                            _vm.isEdit = false
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_Cancel")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.exportExcel }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ExcelExport"))
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]),
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "100%",
                      "flex-grow": "1",
                      height: "95%"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "column-defs": _vm.userOfRoleGrid.columnDefs,
                      "row-data": _vm.userOfRoleGrid.rowData,
                      "grid-options": _vm.userOfRoleGrid.gridOptions
                    },
                    on: { gridReady: _vm.onReady }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "custom-class": "",
            "close-on-click-modal": false,
            visible: _vm.userOfNoCurrentRoleGrid.isShow,
            title: _vm.$t("SystemMaintenance.AddRoleUser"),
            width: "800px;"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.userOfNoCurrentRoleGrid, "isShow", $event)
            },
            close: function($event) {
              _vm.userOfNoCurrentRoleGrid.searchLikeName = ""
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "5px" }
            },
            [
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "50px",
                        "label-position": "left"
                      },
                      nativeOn: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Search") }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "260px" },
                                attrs: { size: "mini", placeholder: "" },
                                on: { input: _vm.toFilterNoCurrentRoleUser },
                                model: {
                                  value:
                                    _vm.userOfNoCurrentRoleGrid.searchLikeName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.userOfNoCurrentRoleGrid,
                                      "searchLikeName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "userOfNoCurrentRoleGrid.searchLikeName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row row-grid-dialog" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.userOfNoCurrentRoleGrid.gridOptions,
                  "column-defs": _vm.userOfNoCurrentRoleGrid.columnDefs,
                  "row-data": _vm.userOfNoCurrentRoleGrid.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.toSaveNoCurrentRoleUser }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.userOfNoCurrentRoleGrid.isShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "custom-class": "",
            "close-on-click-modal": false,
            visible: _vm.userOfNoRoleGrid.isShow,
            title: _vm.$t("SystemMaintenance.AddUserWithUnassignedRole"),
            width: "800px;"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.userOfNoRoleGrid, "isShow", $event)
            },
            close: function($event) {
              _vm.userOfNoRoleGrid.searchLikeName = ""
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "50px",
                        "label-position": "left"
                      },
                      nativeOn: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.Query")
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "260px" },
                                attrs: { size: "mini", placeholder: "" },
                                on: { input: _vm.toFilterNoRoleUser },
                                model: {
                                  value: _vm.userOfNoRoleGrid.searchLikeName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.userOfNoRoleGrid,
                                      "searchLikeName",
                                      $$v
                                    )
                                  },
                                  expression: "userOfNoRoleGrid.searchLikeName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row row-grid-dialog" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.userOfNoRoleGrid.gridOptions,
                  "column-defs": _vm.userOfNoRoleGrid.columnDefs,
                  "row-data": _vm.userOfNoRoleGrid.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.toSaveNoRoleUser }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.userOfNoRoleGrid.isShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "custom-class": "",
            "close-on-click-modal": false,
            visible: _vm.officeDeptTree.isShow,
            title: _vm.$t("SystemMaintenance.SelectDepartment"),
            width: "800px;"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.officeDeptTree, "isShow", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row row-grid-dialog" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", "min-height": "500px" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.officeDeptTree.gridOptions,
                  "column-defs": _vm.officeDeptTree.columnDefs,
                  "row-data": _vm.officeDeptTree.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.toSaveScopeUser }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.officeDeptTree.isShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }